import { RouteObject } from "react-router-dom";
import { lazy } from "react";
// import DashboardPage from "./Dashboard";
// import ProfilePage from "./Profile";
// import Loader from "../utilis/component/Loader";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import dashboard from "./routeList";

const MainDashboard = lazy(() => import("./Dashboard"));

const Reception = lazy(() => import("./Reception"));
import Patients from "./Reception/Patients";

const RadiologyLandingPage = lazy(() => import("./Radiology/LandingPage"));
const RadiologyMainPage = lazy(() => import("./Radiology/RadioDetails/index"));
import PatientWallet from "./Wallet";
import LabLandingPage from "./Lab/LandingPage";
import LabMainPage from "./Lab/LabDetails";
import Loader from "../utilis/component/SkeletonLoading/Loader";
const mainDashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <PrivateRoute>
        <Loader>
            <MainDashboard />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.reception}/:encounterId?/:patientId?`,
    element: (
      <PrivateRoute>
        <Loader>
          <Reception />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.patients}`,
    element: (
      <PrivateRoute>
        <Loader>
          <Patients />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.patientWallet}/:id`,
    element: (
      <PrivateRoute>
        <Loader>
          <PatientWallet  />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.Radiology}`,
    element: (
      <PrivateRoute>
        <Loader>
          <RadiologyLandingPage  />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.Radiology}/:encounterId`,
    element: (
      <PrivateRoute>
        <Loader>
          <RadiologyMainPage />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.lab}`,
    element: (
      <PrivateRoute>
        <Loader>
          <LabLandingPage />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${dashboard.lab}/:encounterId`,
    element: (
      <PrivateRoute>
        <Loader>
          <LabMainPage />
        </Loader>
      </PrivateRoute>
    ),
  },
];

export default mainDashboardRoutes;
